import request from '@/utils/request';

// 普客工作汇报-列表
export function getOrdinaryReportList(params) {
  return request({
    url: '/admin/normal_working_list',
    method: 'get',
    params: params,
  });
}
//普客工作汇报-添加
export function addOrdinaryReport(data) {
  return request({
    url: '/admin/add_normal_working_data',
    method: 'post',
    data: data,
  });
}
//普客工作汇报-上传
export function uploadOrdinaryReport(data) {
  return request({
    url: '/admin/upload_normal_working_data',
    method: 'post',
    data: data,
  });
}
//普客工作汇报-查看
export function viewOrdinaryReport(id) {
  return request({
    url: `/admin/normal_working_info/${id}`,
    method: 'get',
  });
}
//普客工作汇报-编辑
export function editOrdinaryReport(data) {
  return request({
    url: `/admin/check_normal_working_data/${data.id}`,
    method: 'put',
    data: data,
  });
}
//普客工作汇报-删除
export function delOrdinaryReport(id) {
  return request({
    url: `/admin/delete_normal_working_data/${id}`,
    method: 'delete',
  });
}
//普客工作汇报-班次下拉框
export function getDutyList() {
  return request({
    url: '/admin/normal_working_option',
    method: 'get',
  });
}
// 获取质检客服列表
export function getAdminCheckList() {
  return request({
    url: '/admin/admin_user_check_list',
    method: 'get',
  });
}

// 获取账户昵称
export function getUserNicks() {
  return request({
    url: '/admin/get_normal_nickname',
    method: 'POST',
  });
}

